import { useEffect, useState } from 'react';

// Generic debounced-value hook -- pulled out of TransactionsPage.jsx's
// search box so the debounce timing itself is unit-testable (fake timers)
// without mounting the full page, which has too many live data
// dependencies to mount cheaply in a test.
export function useDebouncedValue(value, delayMs) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
